import { createClient } from "@supabase/supabase-js";
import { SUPABASE_PUBLISHABLE_KEY, SUPABASE_URL } from "@/lib/config";
import type { Database } from "./types.extended";

/**
 * The browser client: PKCE + localStorage persistence. `detectSessionInUrl`
 * completes the OAuth code exchange on `/auth/callback` without any server
 * involvement.
 */
export const supabaseClient = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      flowType: "pkce",
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
